import requests from './httpService';

const EnquiryService = {
  submitPublicEnquiry(schooleId, body) {
    return requests.post(`/enquiry/public/${schooleId}`, body);
  },

  listEnquiriesForSchool(schooleId) {
    return requests.get(`/enquiry/admin/${schooleId}`);
  },
};

export default EnquiryService;

